import React from "react";

import "./styles.scss";
import { PremierCollectionBookMobileButtonConnectorProps } from "./container";
import {
  ADD_TRAVELERS,
  ADD_CONTACT_INFO,
  APPLY_REWARDS,
  CONFIRM_AND_BOOK,
} from "./textConstants";
import { MobileFloatingButton } from "halifax";
import { Box } from "@material-ui/core";

export interface IPremierCollectionBookMobileButtonProps
  extends PremierCollectionBookMobileButtonConnectorProps {
  showPaymentStep: boolean;
  hasContactInfo?: boolean;
  isBookingValid: boolean;
  openContactInfo: () => void;
  onApplyRewards: () => void;
  onConfirmAndBook: () => void;
}

export const PremierCollectionBookMobileButton = (
  props: IPremierCollectionBookMobileButtonProps
) => {
  const {
    hasContactInfo,
    selectedTravelerId,
    openContactInfo,
    showPaymentStep,
    onApplyRewards,
    onConfirmAndBook,
    isBookingValid,
  } = props;

  const getButtonText = () => {
    if (!selectedTravelerId) {
      return ADD_TRAVELERS;
    } else if (!hasContactInfo) {
      return ADD_CONTACT_INFO;
    } else if (!showPaymentStep) {
      return APPLY_REWARDS;
    } else {
      return CONFIRM_AND_BOOK;
    }
  };
  const isDisabled = () => {
    if (showPaymentStep && !isBookingValid) return true;

    return false;
  };
  const onClick = () => {
    if (!hasContactInfo) {
      openContactInfo();
    } else if (!showPaymentStep) {
      onApplyRewards();
    } else {
      onConfirmAndBook();
    }
  };

  if (isDisabled()) return null;

  return (
    <Box className="premier-collection-book-mobile-button-container">
      <MobileFloatingButton
        className="premier-collection-book-mobile-button"
        onClick={onClick}
        wrapperClassName="b2b"
      >
        {getButtonText()}
      </MobileFloatingButton>
    </Box>
  );
};
